module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base-module/components/dialog-box/dialog-box.component.scss
// module id = ./src/app/modules/base-module/components/dialog-box/dialog-box.component.scss
// module chunks = 9